/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

import {
    TrendingUp,
    Activity,
    BarChart3,
    AlertTriangle
} from "lucide-react";
import MarketPulse from "../stocks/MarketPulse";
import HomeMarketBreadth from "./HomeMarketBreadth";

export default function HomeMarketPulse() {


    return (
        <section className="mb-20">

            <h2 className="
                text-3xl
                font-bold
                mb-8
                text-slate-900
            ">
                Market Pulse
            </h2>
            <div>
                <MarketPulse/>
            </div>
            <div className="mt-6">
                <HomeMarketBreadth />
            </div>
        </section>
    );
}